<div class="modal-header border-0">
  <span class="fs-3 text-center fw-bold w-100 m-auto"> Otimizar sua Carteira ideal </span>
  <button type="button" class="btn-close" (click)="modalRef.hide()"></button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-12 mt-4">
      <div class="d-flex justify-content-between mb-2">
        <div (click)="changeStep(1, 33)" class="pointer">
          <span class="badge" [ngClass]="{'active' : step == 1}">1</span>
          <span class="badge-description ms-2" [ngClass]="{'active' : step == 1}">Investir / Resgatar</span>
        </div>
        <div (click)="changeStep(2, 66)" class="pointer">
          <span class="badge" [ngClass]="{'active' : step == 2}">2</span>
          <span class="badge-description ms-2" [ngClass]="{'active' : step == 2}">Objetivos</span>
        </div>
        <div (click)="changeStep(3, 100)" class="pointer">
          <span class="badge" [ngClass]="{'active' : step == 3}">3</span>
          <span class="badge-description ms-2" [ngClass]="{'active' : step == 3}">Opcionais</span>
        </div>
      </div>
      <div class="progress w-100">
        <div class="progress-bar" [style.width.%]="progress" role="progressbar" aria-valuenow="20" aria-valuemin="0"
          aria-valuemax="100">
        </div>
      </div>
    </div>
  </div>
  <form autocomplete="off" novalidate>
    <div class="row" *ngIf="step == 1">
      <div class="col-12 my-3">
        <strong>Carteira atual</strong>
        <p class="fs-6 mb-2">
          Re-otimizamos sua carteira atual no valor :
          <strong>{{(total_invested) | currency:'BRL'}}</strong>
          <!-- AINDA NÃO TEMOS ESSA FUNCIONALIDADE -->
          <!-- dos quais <strong>{{extra_financial_value | currency: 'BRL'}}</strong> permanecem disponíveis no caixa. -->
        </p>
        <hr>
        <ng-container *ngIf="rb_account.is_simulation_account; else not_is_simulation_account">
          <strong>Valor simulado </strong>
          <p class="mb-0">Você está simulando uma otimização considerando
            <strong class="text-primary">{{extra_financial_value | currency:'BRL'}}</strong>.
          </p>
          <p class="mb-0">Deseja manter esse valor ou simular outro?</p>                    
        </ng-container>
        <ng-template #not_is_simulation_account>
          <strong>Contas vinculadas </strong>
          <p class="mb-0">Nas contas vinculadas tem
            <strong class="text-primary">{{extra_financial_value | currency:'BRL'}}</strong>
            disponíveis para investir.
          </p>
          <p class="mb-0">Quer aplicar esse ou aportar/retirar qualquer outro valor?</p>          
        </ng-template>        
      </div>
      <div class="col-12 col-md-6 d-flex">
        <input type="text" currencyMask allowNegativeFirst [options]="currencyOption" class="form-control"
          [placeholder]="total_invested | currency:'BRL'" [(ngModel)]="invest_redeem"
          [ngModelOptions]="{standalone: true}" (input)="onInputChange($event)">
        <label class="">&nbsp;*</label>
      </div>
      <div class="col-12 fs-9 mt-2" *ngIf="!rb_account.is_simulation_account">
        * Se preferir, digite um valor negativo para indicar resgate de parte da carteira. O resgate deverá ser feito
        diretamente na corretora.
      </div>
      <div class="col-12">
        <div class="d-flex justify-content-between mb-3 mt-4">
          <button type="button" class="btn  btn-outline-dark ms-0" (click)="modalRef.hide()">VOLTAR</button>
          <button type="button" class="btn btn-primary me-0" [disabled]="!invest_redeem || invest_redeem === 0"
            (click)="changeStep(2, 66)">CONTINUAR</button>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="step == 2">
      <div class="col-12">
        <p class="my-4">
          Para otimizar uma carteira de investimentos, é essencial que você defina seus objetivos financeiros.
        </p>
        <!-- SEM OBJETIVO -->
        <section *ngIf="hasGoals === 0">
          <div class="alert bg-danger text-danger d-flex align-items-center" style="--bs-bg-opacity: 5%" role="alert">
            <icon-svg svgName="danger" class="w-20"></icon-svg>
            <span class="poppins fs-8">
              Para otimizar sua carteira, é importante entender o que você quer conquistar com seus investimentos. Você
              ainda não registrou nenhum objetivo.
            </span>
          </div>
          <!-- <div class="text-center mb-3 mt-5">
            <button type="button" class="btn btn-primary" (click)="adjustGoals()">QUERO AJUSTAR OS OBJETIVOS</button>
          </div> -->
        </section>
        <section *ngIf="hasGoals > 0">
          <div class="alert alert-primary d-flex align-items-center" role="alert">
            <icon-svg svgName="check-success" class="w-10 me-3"></icon-svg>
            <div>
              <span class="poppins fs-8 text-dark">Usando seus objetivos de vida</span>
              <p class="link fs-8 mb-0 fs-8" (click)="adjustGoals()">Quero ajustar os objetivos</p>
            </div>
          </div>
        </section>
        <div class="d-flex justify-content-between mb-3 mt-5">
          <button type="button" class="btn  btn-outline-dark ms-0" (click)="changeStep(1, 33)">VOLTAR</button>
          <button type="button" class="btn btn-primary" (click)="changeStep(3, 100)"
            [disabled]="!hasGoals">CONTINUAR</button>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="step == 3">
      <div class="col-12">
        <p class="fs-6 mt-4 mb-3">
          Você pode incluir seus temas e expectativas sobre os mercados.
        </p>
        <p class="fs-6 fw-semibold">
          Verifique se deseja usar suas visões do mercado e otimizar impostos
          <span class="fs-7 text-danger">&nbsp;(em breve)</span>
        </p>
        <div class="card border flex-row align-items-center px-4 py-2 my-2" [ngClass]="{'bg-active': optional.themes}"
          [class.disabled]="true">
          <input type="checkbox" id="themes" [checked]="optional.themes" (change)="optional.themes = !optional.themes">
          <div class="ms-2">
            <label for="themes" class="poppins text-dark fs-8 m-0">Usando temas definidos</label>
            <p class="link fs-8 mb-0" (click)="adjustThemes()">
              Quero ajustar os temas escolhidos
            </p>
          </div>
        </div>
        <div class="card border flex-row align-items-center px-4 py-2 my-2"
          [ngClass]="{'bg-active': optional.expectations}" [class.disabled]="true">
          <input type="checkbox" id="expectations" [checked]="optional.expectations"
            (change)="optional.expectations = !optional.expectations">
          <div class="ms-2">
            <label for="expectations" class="poppins text-dark fs-8 m-0">Usando minhas expectativas futuras</label>
            <p class="link fs-8 mb-0" (click)="adjustExpectations()">
              Quero ajustar as expectativas
            </p>
          </div>
        </div>
        <div class="card border flex-row align-items-center px-4 py-2 my-2"
          [ngClass]="{'bg-active': optional.incomeTax}" [class.disabled]="true">
          <input type="checkbox" id="income-tax" [checked]="optional.incomeTax"
            (change)="optional.incomeTax = !optional.incomeTax">
          <div class="ms-2">
            <label for="income-tax" class="poppins text-dark fs-8 m-0">Usando imposto de renda</label>
            <p class="fs-8 mb-0" (click)="adjustIncomeTax()">
              (Essa opção estará disponível em breve)
            </p>
          </div>
        </div>
        <div class="d-flex justify-content-between mb-3 mt-5">
          <button type="button" class="btn  btn-outline-dark ms-0" (click)="changeStep(2, 66)">VOLTAR</button>
          <button type="button" class="btn btn-primary me-0" (click)="finish()">OTIMIZAR</button>
        </div>
      </div>
    </div>
  </form>
</div>